import { useSettingsNavigate } from '@frontend/settings-routing';
import { ModalControlModalProps } from '@frontend/design-system';
import { BookingSuccessModal } from '../../../components/onboarding-flow-components/booking-success-modal';
import { useOnboardingFlowInfo } from '../../../hooks/onboarding-flow-hooks/use-onboarding-flow-info';
import { useCheckIsAutoMessagesEnabled } from '../../../hooks/use-check-is-auto-messages-enabled';
import { trackOnboardingFlow } from '../../../utils/track-onboarding-flow';

export const ScheduleOnboardingFlowBookingSuccessModal = (props: ModalControlModalProps) => {
  const { setOnboardingFlowInfo } = useOnboardingFlowInfo();
  const { navigate } = useSettingsNavigate();
  const { isAutoMessagesEnabled } = useCheckIsAutoMessagesEnabled();

  const handlePrimaryActionClick = () => {
    if (isAutoMessagesEnabled) {
      navigate({ to: '/messaging/auto-messages' });
      trackOnboardingFlow('autoMessagedActivated');
    } else {
      navigate({ to: '/subscriptions/manage-subscription' });
      trackOnboardingFlow('upgradeToAutoMessages');
    }

    setOnboardingFlowInfo({ status: 'completed' });
    props.onClose();
  };

  const handleClose = () => {
    trackOnboardingFlow('skippedAutoMessages');
    props.onClose();
  };

  return (
    <BookingSuccessModal
      {...props}
      hasAutoReminder={isAutoMessagesEnabled}
      onCancel={handleClose}
      onPrimaryAction={handlePrimaryActionClick}
    />
  );
};
